<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
  <environment-selector></environment-selector>
  &copy; {{ year }} Bitwarden Inc. <br />
  {{ "versionNumber" | i18n : version }}
</div>
